module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-up.48fb20f3.svg";